import React, { useState } from "react";

//imgs
import icon_1 from '../../../../assets/VAQ_OB_UB_3_1/img/ico-1.png';
import icon_2 from '../../../../assets/VAQ_OB_UB_3_1/img/ico-2.png';
import icon_3 from '../../../../assets/VAQ_OB_UB_3_1/img/ico-3.png';

const Section1 = () => {
  return (
    <>
      <section className="howitworks">
        <div className="container text-center">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-12">
              <img src={icon_1} alt="icon1" />
              <h4>Get your Mis-sold Loan Fees and Charges back</h4>
              <p>Many loans were not sold properly. You could claim back the fees and charges plus 8% interest.</p>
            </div>
            <div className="col-lg-4 col-md-4 col-12 bordr">
              <img src={icon_2} alt="icon2" />
              <h4>Your Claim Fought by Financial &amp; Legal Experts</h4>
              <p>We're ahead of the field, drawing on years of financial services and legal expertise for a strong claim</p>
            </div>
            <div className="col-lg-4 col-md-4 col-12">
              <img src={icon_3} alt="icon3" />
              <h4>Respecting Your Information Security</h4>
              <p>We take security very seriously and follow the rules of the Data Protection Act</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Section1;
